<!--
 * @Descripttion:
 * @version:
 * @Author: AowCt <awoct10@163.com>
 * @Date: 2021-11-08 17:53:58
 * @LastEditors: AowCt <awoct10@163.com>
 * @LastEditTime: 2022-12-07 10:12:29
-->
<template>
  <div >
    <div class="index-banner">
      <div class="swiper" id="indexBanner">
        <div class="swiper-wrapper">
          <div class="swiper-slide index-banner-page1">
            <img class="index-banner-list-bjimg" :src="require('@/assets/images/index/banner/banner1.png')" alt="" srcset="">
            <div class="index-banner-list-wrap">
              <div :class="['index-banner-list-title', language == 'en' ? 'en' : '']" v-html="$t('frontPage.banner.banner1.title').join(' ')"></div>
              <div v-if="language == 'zh'" class="index-banner-list-des">
                <p v-for="(item, index) in $t('frontPage.banner.banner1.des')" :key="index" v-html="item"></p>
              </div>
            </div>
          </div>
          <div class="swiper-slide index-banner-page2">
            <img class="index-banner-list-bjimg" :src="require('@/assets/images/index/banner/banner2.png')" alt="" srcset="">
            <div class="index-banner-list-wrap">
              <div :class="['index-banner-list-title', language == 'en' ? 'en' : '']" v-html="$t('frontPage.banner.banner2.title').join(' ')"></div>
              <div v-if="language == 'zh'" class="index-banner-list-des">
                <p v-for="(item, index) in $t('frontPage.banner.banner2.des')" :key="index" v-html="item"></p>
              </div>
            </div>
          </div>
          <div class="swiper-slide index-banner-page3 flex align_items_center justify_content_center">
            <img class="index-banner-list-bjimg index-banner-list-video" :src="require('@/assets/images/index/banner/banner3.gif')" alt="" srcset="">
            <div class="index-banner-list-wrap">
              <div :class="['index-banner-list-title', language == 'en' ? 'en' : '']" v-html="$t('frontPage.banner.banner3.title').join(' ')"></div>
              <div v-if="language == 'zh'" class="index-banner-list-des">
                <p v-for="(item, index) in $t('frontPage.banner.banner3.des')" :key="index" v-html="item"></p>
              </div>
            </div>
          </div>
        </div>
        <div class="swiper-pagination index-banner-pagination"></div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
  data () {
    return {
    }
  },
  mounted () {
    this.mySwiper = new this.$Swiper('#indexBanner', {
      autoplay: {
        delay: 3000,
        disableOnInteraction: false
      },
      loop: true,
      effect: 'fade',
      pagination: {
        el: '.index-banner-pagination',
        bulletElement: 'li',
        clickable: true
      }
    })
  },
  computed: {
    ...mapGetters(['language'])
  },
  methods: {
  },
  beforeDestroy () {
    this.mySwiper = null
  }
}
</script>

<style lang="less" scoped>
.index-banner{
  .swiper {
    height: 420px;
    .swiper-slide {
      position: relative;
      overflow: hidden;
    }
  }
  // padding-top: 192px;
  // margin-bottom: 90px;
  position: relative;
  color: #ffffff;
  .index-banner-list-bjimg{
      width: 120%;
      height: 120%;
      // transform: scale(1.2, 1.2);
      // -webkit-transform: scale(1.2, 1.2);
      // -moz-transform: scale(1.2, 1.2);
      // -ms-transform: scale(1.2, 1.2);
      // -o-transform: scale(1.2, 1.2);
      // animation: enlarge 3s infinite;
  }
  .index-banner-list-video {
    height: 70%;
    transform: rotate(180deg);
  }
  .index-banner-list-wrap{
    position: absolute;
    top: 0;
    text-align: center;
    width: 100%;
    overflow: hidden;
    height: 100%;
    background: rgba(0, 0, 0, 0.4);
    .index-banner-list-title {
      font-size: 36px;
      font-weight: 300;
      line-height: 84px;
      letter-spacing: 2px;
      font-weight: bold;
      opacity: 0;
      position: absolute;
      width: 100%;
      top: 30%;
      &.en {
        font-size: 28px;
        font-weight: 300;
        line-height: 64px;
        letter-spacing: 2px;
        font-weight: bold;
        opacity: 0;
        position: absolute;
        width: 100%;
        padding: 0 30px;
        top: 30%;
      }
    }
    .index-banner-list-des {
      font-size: 20px;
      line-height: 28px;
      padding: 15px;
      opacity: 0;
      position: absolute;
      width: 100%;
      color: rgba(255, 255, 255, 0.6);
      top: calc(30% + 80px);
    }
  }
  .swiper-slide {
    &.index-banner-page1 {
      .index-banner-list-title{
        left: -100%;
        // letter-spacing: 14px;
      }
      .index-banner-list-des {
        right: -100%;
      }
    }
    &.index-banner-page2 {
      .index-banner-list-title{
        top: 0;
      }
      .index-banner-list-des {
        top: calc(0.8rem);
      }
    }
    &.index-banner-page3 {
      background: #121023;
      .index-banner-list-title, .index-banner-list-des {
        opacity: 1;
      }
      .index-banner-list-bjimg {
        height: 80%;
        width: 80%;
      }
    }
  }
  .swiper-slide-active{
    .index-banner-list-bjimg{
      animation: enlarge 3s;
    }
    &.index-banner-page1 {
      .index-banner-list-title{
        opacity: 1;
        left: 0;
        transition: opacity 2s ease,left 2s ease;
      }
      .index-banner-list-des {
        opacity: 1;
        right: 0;
        transition: opacity 2s ease,right 2s ease;
      }
    }
    &.index-banner-page2 {
      .index-banner-list-title{
        opacity: 1;
        top: 30%;
        transition: opacity 2s ease .5s,top 1s ease .5s;
      }
      .index-banner-list-des {
        opacity: 1;
        top: calc(30% + 80px);
        transition: opacity 2s ease .5s,top 1s ease .5s;
      }
    }
  }
}
</style>

<style lang="less">
.m .index-banner{
  .index-banner-pagination {
    position: absolute;
    height: 24px;
    bottom: 10%;
    .swiper-pagination-bullet {
      width: 22px;
      height: 8px;
      // background: #91DEFF;
      background: #ffffff;
      opacity: 0.6;
      margin: 0 16px;
      border-radius: 7px;
      transition: width 0.3s;
    }
    .swiper-pagination-bullet-active {
      width: 33px;
      background: #ffffff;
      margin: 0 9px;
      opacity: 1;
    }
  }
}
</style>
